import { render, staticRenderFns } from "./SubmitCompleted.vue?vue&type=template&id=4559fe51&"
import script from "./SubmitCompleted.vue?vue&type=script&lang=js&"
export * from "./SubmitCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports